import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, NgZone, ElementRef, EventEmitter, Directive, Output } from '@angular/core';
import { createInjectionToken } from 'ngxtension/create-injection-token';
import { injectDestroy } from 'ngxtension/inject-destroy';
import { Subject, fromEvent, takeUntil, filter } from 'rxjs';

/*
 * This function is used to detect clicks in the document.
 * It is used by the clickOutside directive.
 */
const [injectDocumentClick] = createInjectionToken(() => {
  const click$ = new Subject();
  const [ngZone, document] = [inject(NgZone), inject(DOCUMENT)];
  ngZone.runOutsideAngular(() => {
    fromEvent(document, 'click').subscribe(click$);
  });
  return click$;
});
/*
 * This directive is used to detect clicks outside the element.
 *
 * Example:
 * <div (clickOutside)="close()"></div>
 *
 */
class ClickOutside {
  constructor() {
    this.ngZone = inject(NgZone);
    this.elementRef = inject(ElementRef);
    this.documentClick$ = injectDocumentClick();
    this.destroy$ = injectDestroy();
    /*
     * This event is emitted when a click occurs outside the element.
     */
    this.clickOutside = new EventEmitter();
  }
  ngOnInit() {
    this.documentClick$.pipe(takeUntil(this.destroy$), filter(event => !this.elementRef.nativeElement.contains(event.target))).subscribe(event => {
      this.ngZone.run(() => this.clickOutside.emit(event));
    });
  }
  static {
    this.ɵfac = function ClickOutside_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ClickOutside)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ClickOutside,
      selectors: [["", "clickOutside", ""]],
      outputs: {
        clickOutside: "clickOutside"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClickOutside, [{
    type: Directive,
    args: [{
      selector: '[clickOutside]',
      standalone: true
    }]
  }], null, {
    clickOutside: [{
      type: Output
    }]
  });
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ClickOutside };
